var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page",style:({ height : _vm.$screen.pageHeight + 'px' })},[_vm._t("controls"),_vm._t("title"),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }